/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CarrierDeliveryNoteBundlesArrayV3 } from '../models/carrier-delivery-note-bundles-array-v-3';
import { ConsigneeDeliveryNoteBundlesArrayV3 } from '../models/consignee-delivery-note-bundles-array-v-3';
import { ConsignorDeliveryNoteBundlesArrayV3 } from '../models/consignor-delivery-note-bundles-array-v-3';
import { getCarrierDeliveryNoteBundlesV3 } from '../fn/delivery-note-bundles-v-3/get-carrier-delivery-note-bundles-v-3';
import { GetCarrierDeliveryNoteBundlesV3$Params } from '../fn/delivery-note-bundles-v-3/get-carrier-delivery-note-bundles-v-3';
import { getConsigneeDeliveryNoteBundlesV3 } from '../fn/delivery-note-bundles-v-3/get-consignee-delivery-note-bundles-v-3';
import { GetConsigneeDeliveryNoteBundlesV3$Params } from '../fn/delivery-note-bundles-v-3/get-consignee-delivery-note-bundles-v-3';
import { getConsignorDeliveryNoteBundlesV3 } from '../fn/delivery-note-bundles-v-3/get-consignor-delivery-note-bundles-v-3';
import { GetConsignorDeliveryNoteBundlesV3$Params } from '../fn/delivery-note-bundles-v-3/get-consignor-delivery-note-bundles-v-3';


/**
 * Enhanced delivery note bundle operations with improved pagination, sorting, and filtering capabilities
 */
@Injectable({ providedIn: 'root' })
export class DeliveryNoteBundlesV3Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCarrierDeliveryNoteBundlesV3()` */
  static readonly GetCarrierDeliveryNoteBundlesV3Path = '/organization-sites/{organizationSiteKey}/carrier/delivery-note-bundles';

  /**
   * Get carrier delivery note bundles (v3).
   *
   * Get delivery note bundles for carrier with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch delivery note bundles from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDeliveryNoteBundlesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDeliveryNoteBundlesV3$Response(params: GetCarrierDeliveryNoteBundlesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<CarrierDeliveryNoteBundlesArrayV3>> {
    return getCarrierDeliveryNoteBundlesV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get carrier delivery note bundles (v3).
   *
   * Get delivery note bundles for carrier with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch delivery note bundles from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDeliveryNoteBundlesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDeliveryNoteBundlesV3(params: GetCarrierDeliveryNoteBundlesV3$Params, context?: HttpContext): Observable<CarrierDeliveryNoteBundlesArrayV3> {
    return this.getCarrierDeliveryNoteBundlesV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<CarrierDeliveryNoteBundlesArrayV3>): CarrierDeliveryNoteBundlesArrayV3 => r.body)
    );
  }

  /** Path part for operation `getConsigneeDeliveryNoteBundlesV3()` */
  static readonly GetConsigneeDeliveryNoteBundlesV3Path = '/organization-sites/{organizationSiteKey}/consignee/delivery-note-bundles';

  /**
   * Get consignee delivery note bundles (v3).
   *
   * Get delivery note bundles for consignee with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch delivery note bundles from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDeliveryNoteBundlesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDeliveryNoteBundlesV3$Response(params: GetConsigneeDeliveryNoteBundlesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeDeliveryNoteBundlesArrayV3>> {
    return getConsigneeDeliveryNoteBundlesV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get consignee delivery note bundles (v3).
   *
   * Get delivery note bundles for consignee with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch delivery note bundles from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDeliveryNoteBundlesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDeliveryNoteBundlesV3(params: GetConsigneeDeliveryNoteBundlesV3$Params, context?: HttpContext): Observable<ConsigneeDeliveryNoteBundlesArrayV3> {
    return this.getConsigneeDeliveryNoteBundlesV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConsigneeDeliveryNoteBundlesArrayV3>): ConsigneeDeliveryNoteBundlesArrayV3 => r.body)
    );
  }

  /** Path part for operation `getConsignorDeliveryNoteBundlesV3()` */
  static readonly GetConsignorDeliveryNoteBundlesV3Path = '/organization-sites/{organizationSiteKey}/consignor/delivery-note-bundles';

  /**
   * Get consignor delivery note bundles (v3).
   *
   * Get delivery note bundles for consignor with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch bundles from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsignorDeliveryNoteBundlesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDeliveryNoteBundlesV3$Response(params: GetConsignorDeliveryNoteBundlesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsignorDeliveryNoteBundlesArrayV3>> {
    return getConsignorDeliveryNoteBundlesV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get consignor delivery note bundles (v3).
   *
   * Get delivery note bundles for consignor with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch bundles from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsignorDeliveryNoteBundlesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDeliveryNoteBundlesV3(params: GetConsignorDeliveryNoteBundlesV3$Params, context?: HttpContext): Observable<ConsignorDeliveryNoteBundlesArrayV3> {
    return this.getConsignorDeliveryNoteBundlesV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConsignorDeliveryNoteBundlesArrayV3>): ConsignorDeliveryNoteBundlesArrayV3 => r.body)
    );
  }

}
